/* tslint:disable */
/* eslint-disable */
/**
 * Evidencna aplikacia API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CiselnikPolozka
 */
export interface CiselnikPolozka {
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'nazov': string;
    /**
     * 
     * @type {number}
     * @memberof CiselnikPolozka
     */
    'uroven'?: number;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'kod'?: string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'prefix'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'legislativny'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'platny': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'existujeFormular'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'generovanySystemom'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'povolitZadavanieFormularom'?: boolean;
}
/**
 * 
 * @export
 * @interface DolozkaVplyvov
 */
export interface DolozkaVplyvov {
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'charakterMaterialuNelegislativny'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'charakterMaterialuLegislativny'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'charakterMaterialuTranspozicia'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'zoznamTransponovanychPredpisov'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'terminZaciatkuPpk'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'terminUkonceniaPpk'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'predpokladanyTerminPk'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'predpokladanyTerminZp'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'predpokladanyTerminRokovanieVlady'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'definovanieProblemu'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'cieleAVyslednyStav'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'dotknuteSubjekty'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'alternativneRiesenia'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vykonavaciePredpisyAno'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'vykonavaciePredpisyText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'transpoziciaGoldplatingAno'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'transpoziciaPravaEuText'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'preskumanieUcelnosti'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyRozpocetVerejnejSpravyPozitivne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyRozpocetVerejnejSpravyZiadne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyRozpocetVerejnejSpravyNegativne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyRozpocetVerejnejSpravyZabezpeceneAno'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyRozpocetVerejnejSpravyZabezpeceneNie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyRozpocetVerejnejSpravyZabezpeceneCiastocne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyRozpoctyObciAVucPozitivne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyRozpoctyObciAVucZiadne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyRozpoctyObciAVucNegativne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyRozpoctyObciAVucZabezpeceneAno'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyRozpoctyObciAVucZabezpeceneNie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyRozpoctyObciAVucZabezpeceneCiastocne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvNaUdrzatelnostAno'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvNaUdrzatelnostNie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyPodnikatelskeProstrediePozitivne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyPodnikatelskeProstredieZiadne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyPodnikatelskeProstredieNegativne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyPodnikatelskeProstredieMspPozitivne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyPodnikatelskeProstredieMspZiadne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyPodnikatelskeProstredieMspNegativne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyPodnikatelskeProstredieZnizovanieByrokracieAno'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyPodnikatelskeProstredieZnizovanieByrokracieNie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyNaLimitVydavkovPozitivne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyNaLimitVydavkovZiadne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyNaLimitVydavkovNegativne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'socialneVplyvyPozitivne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'socialneVplyvyZiadne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'socialneVplyvyNegativne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyZivotneProstrediePozitivne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyZivotneProstredieZiadne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyZivotneProstredieNegativne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'posudzovanyPodlaZakonaAno'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'posudzovanyPodlaZakonaNie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyInformatizaciaSpolocnostiPozitivne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyInformatizaciaSpolocnostiZiadne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyInformatizaciaSpolocnostiNegativne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyVerejnaSpravaObcanPozitivne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyVerejnaSpravaObcanZiadne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyVerejnaSpravaObcanNegativne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyProcesyVerejnejSpravyPozitivne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyProcesyVerejnejSpravyZiadne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyProcesyVerejnejSpravyNegativne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyManzelstvoRodicovstvoPozitivne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyManzelstvoRodicovstvoZiadne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'vplyvyManzelstvoRodicovstvoNegativne'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'poznamky'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'kontaktSpracovatel'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'zdroje'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'stanoviskoPpkC'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'stanoviskoPpkSuhlasne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'stanoviskoPpkSuhlasneNaDopracovanie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'stanoviskoPpkNesuhlasne'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'stanoviskoPpkVyhodnotenie'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'stanoviskoPosudenieC'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'stanoviskoPosudenieSuhlasne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'stanoviskoPosudenieSuhlasneNaDopracovanie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaVplyvov
     */
    'stanoviskoPosudenieNesuhlasne'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DolozkaVplyvov
     */
    'stanoviskoPosudenieVyhodnotenie'?: string;
}
/**
 * 
 * @export
 * @interface DolozkaZlucitelnosti
 */
export interface DolozkaZlucitelnosti {
    /**
     * 
     * @type {boolean}
     * @memberof DolozkaZlucitelnosti
     */
    'upravenyVPraveEu'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DolozkaZlucitelnosti
     */
    'primarnePravo'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaZlucitelnosti
     */
    'sekundarnePravo'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaZlucitelnosti
     */
    'judikaturaSudnehoDvoraEu'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaZlucitelnosti
     */
    'lehotaPravnyAktEu'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaZlucitelnosti
     */
    'informaciaZacatieKonania'?: string;
    /**
     * 
     * @type {string}
     * @memberof DolozkaZlucitelnosti
     */
    'informaciaPravnePredpisy'?: string;
    /**
     * 
     * @type {ZlucitelnostSPravomEuEnum}
     * @memberof DolozkaZlucitelnosti
     */
    'zlucitelnostSPravomEu'?: ZlucitelnostSPravomEuEnum;
    /**
     * 
     * @type {string}
     * @memberof DolozkaZlucitelnosti
     */
    'dovody'?: string;
}


/**
 * 
 * @export
 * @interface FormData
 */
export interface FormData {
    /**
     * 
     * @type {string}
     * @memberof FormData
     */
    'formData': string;
    /**
     * 
     * @type {Stadium}
     * @memberof FormData
     */
    'stadium': Stadium;
}
/**
 * 
 * @export
 * @interface NavrhUzneseniaVlady
 */
export interface NavrhUzneseniaVlady {
    /**
     * 
     * @type {boolean}
     * @memberof NavrhUzneseniaVlady
     */
    'isUznesenie'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NavrhUzneseniaVlady
     */
    'nazovMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof NavrhUzneseniaVlady
     */
    'cisloMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof NavrhUzneseniaVlady
     */
    'predkladatel'?: string;
    /**
     * 
     * @type {Array<NavrhUzneseniaVladyCast>}
     * @memberof NavrhUzneseniaVlady
     */
    'castList'?: Array<NavrhUzneseniaVladyCast>;
    /**
     * 
     * @type {string}
     * @memberof NavrhUzneseniaVlady
     */
    'vykonaju'?: string;
    /**
     * 
     * @type {string}
     * @memberof NavrhUzneseniaVlady
     */
    'naVedomie'?: string;
}
/**
 * 
 * @export
 * @interface NavrhUzneseniaVladyBod
 */
export interface NavrhUzneseniaVladyBod {
    /**
     * 
     * @type {string}
     * @memberof NavrhUzneseniaVladyBod
     */
    'bod'?: string;
    /**
     * 
     * @type {string}
     * @memberof NavrhUzneseniaVladyBod
     */
    'zodpovednaOsoba'?: string;
    /**
     * 
     * @type {string}
     * @memberof NavrhUzneseniaVladyBod
     */
    'termin'?: string;
    /**
     * 
     * @type {string}
     * @memberof NavrhUzneseniaVladyBod
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface NavrhUzneseniaVladyCast
 */
export interface NavrhUzneseniaVladyCast {
    /**
     * 
     * @type {string}
     * @memberof NavrhUzneseniaVladyCast
     */
    'cast'?: string;
    /**
     * 
     * @type {string}
     * @memberof NavrhUzneseniaVladyCast
     */
    'zamerCasti'?: string;
    /**
     * 
     * @type {Array<NavrhUzneseniaVladyBod>}
     * @memberof NavrhUzneseniaVladyCast
     */
    'bodList'?: Array<NavrhUzneseniaVladyBod>;
}
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {NotificationTypeEnum}
     * @memberof Notification
     */
    'notificationType': NotificationTypeEnum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationTypeEnum = {
    NamietkaUrcenieGestorstva: 'NAMIETKA_URCENIE_GESTORSTVA',
    OdmietnutieGestora: 'ODMIETNUTIE_GESTORA',
    PodpisPredsedu: 'PODPIS_PREDSEDU',
    PrichodNovejAktivity: 'PRICHOD_NOVEJ_AKTIVITY',
    RokovanieNrSr: 'ROKOVANIE_NR_SR',
    SledovanaLegislativnaOblast: 'SLEDOVANA_LEGISLATIVNA_OBLAST',
    SledovanaLegislativnaOblastPi: 'SLEDOVANA_LEGISLATIVNA_OBLAST_PI',
    SledovanyMaterial: 'SLEDOVANY_MATERIAL',
    SpustenieMpk: 'SPUSTENIE_MPK',
    UkoncenieAktEu: 'UKONCENIE_AKT_EU',
    ZaciatokAktEu: 'ZACIATOK_AKT_EU',
    ZaciatokRokovaniaPov: 'ZACIATOK_ROKOVANIA_POV',
    ZmenaPredkladatela: 'ZMENA_PREDKLADATELA',
    ZmenaStupnaDolezitosti: 'ZMENA_STUPNA_DOLEZITOSTI',
    ZrusenieMpk: 'ZRUSENIE_MPK',
    VyhlasenePredpisy: 'VYHLASENE_PREDPISY',
    NahlasenieChyby: 'NAHLASENIE_CHYBY',
    PredbezneStanovisko: 'PREDBEZNE_STANOVISKO',
    DoplnenePredbezneStanovisko: 'DOPLNENE_PREDBEZNE_STANOVISKO'
} as const;

export type NotificationTypeEnum = typeof NotificationTypeEnum[keyof typeof NotificationTypeEnum];


/**
 * 
 * @export
 * @interface NotifikaciaHistoria
 */
export interface NotifikaciaHistoria {
    /**
     * 
     * @type {string}
     * @memberof NotifikaciaHistoria
     */
    'uuid': string;
    /**
     * 
     * @type {NotificationTypeEnum}
     * @memberof NotifikaciaHistoria
     */
    'typ': NotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotifikaciaHistoria
     */
    'datumOdoslania': string;
}


/**
 * 
 * @export
 * @interface NotifikaciaHistoriaPage
 */
export interface NotifikaciaHistoriaPage {
    /**
     * total count of elements
     * @type {number}
     * @memberof NotifikaciaHistoriaPage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof NotifikaciaHistoriaPage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof NotifikaciaHistoriaPage
     */
    'size': number;
    /**
     * 
     * @type {Array<NotifikaciaHistoria>}
     * @memberof NotifikaciaHistoriaPage
     */
    'notifikaciaHistoriaList'?: Array<NotifikaciaHistoria>;
}
/**
 * 
 * @export
 * @interface ObalMaterialu
 */
export interface ObalMaterialu {
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialu
     */
    'nazovVygenerovanehoDokumentu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialu
     */
    'zodpovednaInstitucia'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialu
     */
    'rezortneCislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialu
     */
    'typObalu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialu
     */
    'navrh'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialu
     */
    'typMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialu
     */
    'rok'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialu
     */
    'nazovMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialu
     */
    'podnet'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialu
     */
    'obsahMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialu
     */
    'predkladatel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialu
     */
    'miestoDatum'?: string;
}
/**
 * 
 * @export
 * @interface ObalMaterialuNrSr
 */
export interface ObalMaterialuNrSr {
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSr
     */
    'rezortneCislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSr
     */
    'cisloParlamentnejTlace'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSr
     */
    'vladnyNavrh'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSr
     */
    'typMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSr
     */
    'nazovMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSr
     */
    'navrhUznesenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSr
     */
    'predkladatel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSr
     */
    'miestoDatum'?: string;
}
/**
 * 
 * @export
 * @interface ObalMaterialuNrSrBezchybnost
 */
export interface ObalMaterialuNrSrBezchybnost {
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSrBezchybnost
     */
    'zodpovednyPredkladatel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSrBezchybnost
     */
    'zaBezchybnost'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSrBezchybnost
     */
    'rezortneCislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSrBezchybnost
     */
    'cisloParlamentnejTlace'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSrBezchybnost
     */
    'vladnyNavrh'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSrBezchybnost
     */
    'typMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSrBezchybnost
     */
    'nazovMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSrBezchybnost
     */
    'navrhUznesenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSrBezchybnost
     */
    'predkladatel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSrBezchybnost
     */
    'miestoDatum'?: string;
}
/**
 * 
 * @export
 * @interface ObalMaterialuNrSrUpdate
 */
export interface ObalMaterialuNrSrUpdate {
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuNrSrUpdate
     */
    'sprievodnyDokumentUuid'?: string;
    /**
     * 
     * @type {ObalMaterialuNrSr}
     * @memberof ObalMaterialuNrSrUpdate
     */
    'obalMaterialu'?: ObalMaterialuNrSr;
}
/**
 * 
 * @export
 * @interface ObalMaterialuUpdate
 */
export interface ObalMaterialuUpdate {
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialuUpdate
     */
    'sprievodnyDokumentUuid'?: string;
    /**
     * 
     * @type {ObalMaterialu}
     * @memberof ObalMaterialuUpdate
     */
    'obalMaterialu'?: ObalMaterialu;
}
/**
 * 
 * @export
 * @interface Organizacia
 */
export interface Organizacia {
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'skratenyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'uplnyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'ldapUuid'?: string;
}
/**
 * 
 * @export
 * @interface Page
 */
export interface Page {
    /**
     * total count of elements
     * @type {number}
     * @memberof Page
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof Page
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof Page
     */
    'size': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortDirectionEnum = typeof SortDirectionEnum[keyof typeof SortDirectionEnum];


/**
 * 
 * @export
 * @interface SpravaOUcastiVerejnosti
 */
export interface SpravaOUcastiVerejnosti {
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'informovanie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'prerokovanie'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpravaOUcastiVerejnosti
     */
    'odovodnenieZapojenieVerejnosti'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'predbeznaInformacia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'legislativnyZamer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'ineSposobInformovaniaVerejnosti'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpravaOUcastiVerejnosti
     */
    'ineSposobInformovaniaVerejnostiText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'oprobleme'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'osposobeZapojenia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'ocasovomRamci'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'oprocese'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'osposobeNalozenia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'ineInformacieVerejnosti'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpravaOUcastiVerejnosti
     */
    'ineInformacieVerejnostiText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'formaOsobne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'formaUstne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'formaPisomne'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'formaIne'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpravaOUcastiVerejnosti
     */
    'formaIneText'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpravaOUcastiVerejnosti
     */
    'formaOdovodnenie'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'pracovnaSkupina'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'konferencia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'diskusiaKLegislativnemuProcesu'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'konzultacia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'pripomienkovanie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'inePrerokovanieVerejnostou'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpravaOUcastiVerejnosti
     */
    'inePrerokovanieVerejnostouText'?: string;
    /**
     * 
     * @type {Subjekty}
     * @memberof SpravaOUcastiVerejnosti
     */
    'vyzvane'?: Subjekty;
    /**
     * 
     * @type {Subjekty}
     * @memberof SpravaOUcastiVerejnosti
     */
    'zucastnene'?: Subjekty;
    /**
     * 
     * @type {string}
     * @memberof SpravaOUcastiVerejnosti
     */
    'vyzvaneOdovodnenie'?: string;
    /**
     * 
     * @type {Subjekty}
     * @memberof SpravaOUcastiVerejnosti
     */
    'prejaviliZaujem'?: Subjekty;
    /**
     * 
     * @type {Subjekty}
     * @memberof SpravaOUcastiVerejnosti
     */
    'iniciativneZucastnene'?: Subjekty;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'organyVerejnejSpravy'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'zaujmoveZdruzenia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'podnikatelia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'mimovladneANeziskoveOrg'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'akademickaAVedeckaObec'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'cirkvi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpravaOUcastiVerejnosti
     */
    'ine'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpravaOUcastiVerejnosti
     */
    'ineText'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpravaOUcastiVerejnosti
     */
    'sposobNalozeniaOdovodnenie'?: string;
    /**
     * 
     * @type {string}
     * @memberof SpravaOUcastiVerejnosti
     */
    'vyhodnotenieUcastiOdovodnenie'?: string;
}
/**
 * 
 * @export
 * @interface SprievodnyDokument
 */
export interface SprievodnyDokument {
    /**
     * 
     * @type {string}
     * @memberof SprievodnyDokument
     */
    'formData'?: string;
    /**
     * 
     * @type {string}
     * @memberof SprievodnyDokument
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SprievodnyDokument
     */
    'dmsId': string;
    /**
     * 
     * @type {string}
     * @memberof SprievodnyDokument
     */
    'nazov'?: string;
    /**
     * 
     * @type {number}
     * @memberof SprievodnyDokument
     */
    'velkost'?: number;
    /**
     * 
     * @type {CiselnikPolozka}
     * @memberof SprievodnyDokument
     */
    'typ'?: CiselnikPolozka;
    /**
     * 
     * @type {StadiumMaterialuHistoria}
     * @memberof SprievodnyDokument
     */
    'stadiumMaterialuHistoria'?: StadiumMaterialuHistoria;
}
/**
 * 
 * @export
 * @interface SprievodnyDokumentStatus
 */
export interface SprievodnyDokumentStatus {
    /**
     * 
     * @type {SprievodnyDokumentStatusEnum}
     * @memberof SprievodnyDokumentStatus
     */
    'status'?: SprievodnyDokumentStatusEnum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SprievodnyDokumentStatusEnum = {
    DocumentExists: 'DOCUMENT_EXISTS',
    DocumentNotFound: 'DOCUMENT_NOT_FOUND'
} as const;

export type SprievodnyDokumentStatusEnum = typeof SprievodnyDokumentStatusEnum[keyof typeof SprievodnyDokumentStatusEnum];


/**
 * 
 * @export
 * @interface Stadium
 */
export interface Stadium {
    /**
     * 
     * @type {StadiumMaterialuEnum}
     * @memberof Stadium
     */
    'hodnota': StadiumMaterialuEnum;
    /**
     * 
     * @type {string}
     * @memberof Stadium
     */
    'nazov': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const StadiumMaterialuEnum = {
    FinalnePredbezneStanovisko: 'FINALNE_PREDBEZNE_STANOVISKO',
    Mpk: 'MPK',
    PredVyhlasenimVZbierke: 'PRED_VYHLASENIM_V_ZBIERKE',
    PredpripravnaFazaUkoncena: 'PREDPRIPRAVNA_FAZA_UKONCENA',
    PripravaMaterialu: 'PRIPRAVA_MATERIALU',
    PriradenieGestora: 'PRIRADENIE_GESTORA',
    ProcesUkonceny: 'PROCES_UKONCENY',
    RokovanieNrsr: 'ROKOVANIE_NRSR',
    RokovaniePov: 'ROKOVANIE_POV',
    RokovanieVlada: 'ROKOVANIE_VLADA',
    SchvalenieGestora: 'SCHVALENIE_GESTORA',
    SchvalovanieMinister: 'SCHVALOVANIE_MINISTER',
    SpracovaniePredkladatel: 'SPRACOVANIE_PREDKLADATEL',
    VyhlaseneVZbierke: 'VYHLASENE_V_ZBIERKE',
    VyhodnotenieMpk: 'VYHODNOTENIE_MPK',
    VyhodnotenieMpkAkty: 'VYHODNOTENIE_MPK_AKTY',
    Vyjadrenia: 'VYJADRENIA',
    ZapisStanoviska: 'ZAPIS_STANOVISKA',
    ZapisPredbeznehoStanoviska: 'ZAPIS_PREDBEZNEHO_STANOVISKA',
    ZapisDoplnenehoPredbeznehoStanoviska: 'ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA',
    AdministraciaProcesu: 'ADMINISTRACIA_PROCESU',
    AproximaciaNariadenia: 'APROXIMACIA_NARIADENIA',
    AproximaciaSmernice: 'APROXIMACIA_SMERNICE',
    ArchivovanyAeu: 'ARCHIVOVANY_AEU',
    CakajuciPubMod: 'CAKAJUCI_PUB_MOD',
    DoplneniePozicie: 'DOPLNENIE_POZICIE',
    FinalizaciaInstrukcie: 'FINALIZACIA_INSTRUKCIE',
    FinalizaciaNotifikacnychFormularov: 'FINALIZACIA_NOTIFIKACNYCH_FORMULAROV',
    FinalizaciaPozicie: 'FINALIZACIA_POZICIE',
    KontrolaRedakcUprav: 'KONTROLA_REDAKC_UPRAV',
    MzvEz: 'MZV_EZ',
    NotifikacnyFormular: 'NOTIFIKACNY_FORMULAR',
    OdoslaneRokovanieNrsr: 'ODOSLANE_ROKOVANIE_NRSR',
    OdoslaneRokovanieVlady: 'ODOSLANE_ROKOVANIE_VLADY',
    OdoslaneZz: 'ODOSLANE_ZZ',
    PredPublikovanim: 'PRED_PUBLIKOVANIM',
    PriebezneZapracovaniePrip: 'PRIEBEZNE_ZAPRACOVANIE_PRIP',
    PripomienkovaniePozmenNavrhovNrsr: 'PRIPOMIENKOVANIE_POZMEN_NAVRHOV_NRSR',
    PripravaMaterialuAdmin: 'PRIPRAVA_MATERIALU_ADMIN',
    PripravaMaterialuPi: 'PRIPRAVA_MATERIALU_PI',
    PripravaNelegMaterialu: 'PRIPRAVA_NELEG_MATERIALU',
    PriradenieGestoraCoreper: 'PRIRADENIE_GESTORA_COREPER',
    PriradenieGestoraNariadenie: 'PRIRADENIE_GESTORA_NARIADENIE',
    PriradenieGestoraRadaEu: 'PRIRADENIE_GESTORA_RADA_EU',
    PriradenieGestoraSmernica: 'PRIRADENIE_GESTORA_SMERNICA',
    PublikaciaRo: 'PUBLIKACIA_RO',
    RokovanieLrv: 'ROKOVANIE_LRV',
    RokovanieNrsrNelegMat: 'ROKOVANIE_NRSR_NELEG_MAT',
    RokovaniePracKomisii: 'ROKOVANIE_PRAC_KOMISII',
    RokovaniePredkladatel: 'ROKOVANIE_PREDKLADATEL',
    RokovaniePredkladatelNelegMat: 'ROKOVANIE_PREDKLADATEL_NELEG_MAT',
    RokovanieVladaNelegMat: 'ROKOVANIE_VLADA_NELEG_MAT',
    SefredaktorPridelovanie: 'SEFREDAKTOR_PRIDELOVANIE',
    SefredaktorSchvaleniePredPubmod: 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD',
    SefredaktorSchvaleniePredPubmodNelegMat: 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD_NELEG_MAT',
    SchvaleneNaVlade: 'SCHVALENE_NA_VLADE',
    SchvalovaniePrezident: 'SCHVALOVANIE_PREZIDENT',
    SpracovanieRedaktor: 'SPRACOVANIE_REDAKTOR',
    SpracovanieRedaktorNelegMat: 'SPRACOVANIE_REDAKTOR_NELEG_MAT',
    SpracovanieSefredaktor: 'SPRACOVANIE_SEFREDAKTOR',
    SpracovanieSefredaktorNelegMat: 'SPRACOVANIE_SEFREDAKTOR_NELEG_MAT',
    VyhodnotenieMpkNelegMat: 'VYHODNOTENIE_MPK_NELEG_MAT',
    VyhodnotenieRokovaniaNrsr: 'VYHODNOTENIE_ROKOVANIA_NRSR',
    VyhodnotenieVysledkuRokovania: 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA',
    VyhodnotenieVysledkuRokovaniaNelegMat: 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA_NELEG_MAT',
    VytvorenieCiastkovejInstrukcie: 'VYTVORENIE_CIASTKOVEJ_INSTRUKCIE',
    VytvoreniePozicie: 'VYTVORENIE_POZICIE',
    ZaevidovanieMaterialu: 'ZAEVIDOVANIE_MATERIALU',
    ZaevidovanieOpatrenia: 'ZAEVIDOVANIE_OPATRENIA'
} as const;

export type StadiumMaterialuEnum = typeof StadiumMaterialuEnum[keyof typeof StadiumMaterialuEnum];


/**
 * 
 * @export
 * @interface StadiumMaterialuHistoria
 */
export interface StadiumMaterialuHistoria {
    /**
     * 
     * @type {string}
     * @memberof StadiumMaterialuHistoria
     */
    'uuid': string;
    /**
     * 
     * @type {Stadium}
     * @memberof StadiumMaterialuHistoria
     */
    'stadium': Stadium;
    /**
     * 
     * @type {string}
     * @memberof StadiumMaterialuHistoria
     */
    'datumZacatia': string;
    /**
     * 
     * @type {string}
     * @memberof StadiumMaterialuHistoria
     */
    'datumUkoncenia'?: string;
    /**
     * 
     * @type {Organizacia}
     * @memberof StadiumMaterialuHistoria
     */
    'vlastnikAktivity'?: Organizacia;
}
/**
 * 
 * @export
 * @interface StadiumMaterialuHistoriaList
 */
export interface StadiumMaterialuHistoriaList {
    /**
     * 
     * @type {Array<StadiumMaterialuHistoria>}
     * @memberof StadiumMaterialuHistoriaList
     */
    'historiaRecords'?: Array<StadiumMaterialuHistoria>;
}
/**
 * 
 * @export
 * @interface Subjekty
 */
export interface Subjekty {
    /**
     * 
     * @type {number}
     * @memberof Subjekty
     */
    'zaujmoveZdruzenia'?: number;
    /**
     * 
     * @type {number}
     * @memberof Subjekty
     */
    'podnikatelia'?: number;
    /**
     * 
     * @type {number}
     * @memberof Subjekty
     */
    'mimovladneANeziskoveOrg'?: number;
    /**
     * 
     * @type {number}
     * @memberof Subjekty
     */
    'akademickaAVedeckaObec'?: number;
    /**
     * 
     * @type {number}
     * @memberof Subjekty
     */
    'cirkvi'?: number;
    /**
     * 
     * @type {number}
     * @memberof Subjekty
     */
    'ine'?: number;
    /**
     * 
     * @type {string}
     * @memberof Subjekty
     */
    'ineText'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ZlucitelnostSPravomEuEnum = {
    Ciastocne: 'CIASTOCNE',
    Uplne: 'UPLNE',
    NieJe: 'NIE_JE'
} as const;

export type ZlucitelnostSPravomEuEnum = typeof ZlucitelnostSPravomEuEnum[keyof typeof ZlucitelnostSPravomEuEnum];



/**
 * DocumentFormDataApi - axios parameter creator
 * @export
 */
export const DocumentFormDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get form data of sprievodny dokument in stadium
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentFormData: async (uuid: string, sprievodnyDokumentKod: string, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getDocumentFormData', 'uuid', uuid)
            // verify required parameter 'sprievodnyDokumentKod' is not null or undefined
            assertParamExists('getDocumentFormData', 'sprievodnyDokumentKod', sprievodnyDokumentKod)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/{sprievodnyDokumentKod}/detail`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"sprievodnyDokumentKod"}}`, encodeURIComponent(String(sprievodnyDokumentKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get latest created form data of sprievodny dokument
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestDocumentFormData: async (uuid: string, sprievodnyDokumentKod: string, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getLatestDocumentFormData', 'uuid', uuid)
            // verify required parameter 'sprievodnyDokumentKod' is not null or undefined
            assertParamExists('getLatestDocumentFormData', 'sprievodnyDokumentKod', sprievodnyDokumentKod)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/{sprievodnyDokumentKod}/latest-detail`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"sprievodnyDokumentKod"}}`, encodeURIComponent(String(sprievodnyDokumentKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentFormDataApi - functional programming interface
 * @export
 */
export const DocumentFormDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentFormDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Get form data of sprievodny dokument in stadium
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentFormData(uuid: string, sprievodnyDokumentKod: string, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentFormData(uuid, sprievodnyDokumentKod, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentFormDataApi.getDocumentFormData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get latest created form data of sprievodny dokument
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestDocumentFormData(uuid: string, sprievodnyDokumentKod: string, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestDocumentFormData(uuid, sprievodnyDokumentKod, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentFormDataApi.getLatestDocumentFormData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentFormDataApi - factory interface
 * @export
 */
export const DocumentFormDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentFormDataApiFp(configuration)
    return {
        /**
         * Get form data of sprievodny dokument in stadium
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentFormData(uuid: string, sprievodnyDokumentKod: string, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getDocumentFormData(uuid, sprievodnyDokumentKod, stadiumUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get latest created form data of sprievodny dokument
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestDocumentFormData(uuid: string, sprievodnyDokumentKod: string, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<FormData> {
            return localVarFp.getLatestDocumentFormData(uuid, sprievodnyDokumentKod, stadiumUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentFormDataApi - object-oriented interface
 * @export
 * @class DocumentFormDataApi
 * @extends {BaseAPI}
 */
export class DocumentFormDataApi extends BaseAPI {
    /**
     * Get form data of sprievodny dokument in stadium
     * @param {string} uuid Primary key of entity
     * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentFormDataApi
     */
    public getDocumentFormData(uuid: string, sprievodnyDokumentKod: string, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return DocumentFormDataApiFp(this.configuration).getDocumentFormData(uuid, sprievodnyDokumentKod, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get latest created form data of sprievodny dokument
     * @param {string} uuid Primary key of entity
     * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentFormDataApi
     */
    public getLatestDocumentFormData(uuid: string, sprievodnyDokumentKod: string, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return DocumentFormDataApiFp(this.configuration).getLatestDocumentFormData(uuid, sprievodnyDokumentKod, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DolozkaVplyvovApi - axios parameter creator
 * @export
 */
export const DolozkaVplyvovApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create sprievodny dokument Dolozka vplyvov from form data
         * @param {string} uuid Primary key of entity
         * @param {DolozkaVplyvov} dolozkaVplyvov 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDolozkaVplyvov: async (uuid: string, dolozkaVplyvov: DolozkaVplyvov, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('createDolozkaVplyvov', 'uuid', uuid)
            // verify required parameter 'dolozkaVplyvov' is not null or undefined
            assertParamExists('createDolozkaVplyvov', 'dolozkaVplyvov', dolozkaVplyvov)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/dolozka-vplyvov`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dolozkaVplyvov, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit sprievodny dokument Dolozka vplyvov form data
         * @param {string} uuid Primary key of entity
         * @param {DolozkaVplyvov} dolozkaVplyvov 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDolozkaVplyvov: async (uuid: string, dolozkaVplyvov: DolozkaVplyvov, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('editDolozkaVplyvov', 'uuid', uuid)
            // verify required parameter 'dolozkaVplyvov' is not null or undefined
            assertParamExists('editDolozkaVplyvov', 'dolozkaVplyvov', dolozkaVplyvov)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/dolozka-vplyvov`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dolozkaVplyvov, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DolozkaVplyvovApi - functional programming interface
 * @export
 */
export const DolozkaVplyvovApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DolozkaVplyvovApiAxiosParamCreator(configuration)
    return {
        /**
         * Create sprievodny dokument Dolozka vplyvov from form data
         * @param {string} uuid Primary key of entity
         * @param {DolozkaVplyvov} dolozkaVplyvov 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDolozkaVplyvov(uuid: string, dolozkaVplyvov: DolozkaVplyvov, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDolozkaVplyvov(uuid, dolozkaVplyvov, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DolozkaVplyvovApi.createDolozkaVplyvov']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit sprievodny dokument Dolozka vplyvov form data
         * @param {string} uuid Primary key of entity
         * @param {DolozkaVplyvov} dolozkaVplyvov 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editDolozkaVplyvov(uuid: string, dolozkaVplyvov: DolozkaVplyvov, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editDolozkaVplyvov(uuid, dolozkaVplyvov, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DolozkaVplyvovApi.editDolozkaVplyvov']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DolozkaVplyvovApi - factory interface
 * @export
 */
export const DolozkaVplyvovApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DolozkaVplyvovApiFp(configuration)
    return {
        /**
         * Create sprievodny dokument Dolozka vplyvov from form data
         * @param {string} uuid Primary key of entity
         * @param {DolozkaVplyvov} dolozkaVplyvov 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDolozkaVplyvov(uuid: string, dolozkaVplyvov: DolozkaVplyvov, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createDolozkaVplyvov(uuid, dolozkaVplyvov, stadiumUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit sprievodny dokument Dolozka vplyvov form data
         * @param {string} uuid Primary key of entity
         * @param {DolozkaVplyvov} dolozkaVplyvov 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDolozkaVplyvov(uuid: string, dolozkaVplyvov: DolozkaVplyvov, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.editDolozkaVplyvov(uuid, dolozkaVplyvov, stadiumUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DolozkaVplyvovApi - object-oriented interface
 * @export
 * @class DolozkaVplyvovApi
 * @extends {BaseAPI}
 */
export class DolozkaVplyvovApi extends BaseAPI {
    /**
     * Create sprievodny dokument Dolozka vplyvov from form data
     * @param {string} uuid Primary key of entity
     * @param {DolozkaVplyvov} dolozkaVplyvov 
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DolozkaVplyvovApi
     */
    public createDolozkaVplyvov(uuid: string, dolozkaVplyvov: DolozkaVplyvov, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return DolozkaVplyvovApiFp(this.configuration).createDolozkaVplyvov(uuid, dolozkaVplyvov, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit sprievodny dokument Dolozka vplyvov form data
     * @param {string} uuid Primary key of entity
     * @param {DolozkaVplyvov} dolozkaVplyvov 
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DolozkaVplyvovApi
     */
    public editDolozkaVplyvov(uuid: string, dolozkaVplyvov: DolozkaVplyvov, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return DolozkaVplyvovApiFp(this.configuration).editDolozkaVplyvov(uuid, dolozkaVplyvov, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DolozkaZlucitelnostiApi - axios parameter creator
 * @export
 */
export const DolozkaZlucitelnostiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create sprievodny dokument Dolozka zlucitelnosti from form data
         * @param {string} uuid Primary key of entity
         * @param {DolozkaZlucitelnosti} dolozkaZlucitelnosti 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDolozkaZlucitelnosti: async (uuid: string, dolozkaZlucitelnosti: DolozkaZlucitelnosti, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('createDolozkaZlucitelnosti', 'uuid', uuid)
            // verify required parameter 'dolozkaZlucitelnosti' is not null or undefined
            assertParamExists('createDolozkaZlucitelnosti', 'dolozkaZlucitelnosti', dolozkaZlucitelnosti)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/dolozka-zlucitelnosti`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dolozkaZlucitelnosti, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit sprievodny dokument Dolozka zlucitelnosti form data
         * @param {string} uuid Primary key of entity
         * @param {DolozkaZlucitelnosti} dolozkaZlucitelnosti 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDolozkaZlucitelnosti: async (uuid: string, dolozkaZlucitelnosti: DolozkaZlucitelnosti, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('editDolozkaZlucitelnosti', 'uuid', uuid)
            // verify required parameter 'dolozkaZlucitelnosti' is not null or undefined
            assertParamExists('editDolozkaZlucitelnosti', 'dolozkaZlucitelnosti', dolozkaZlucitelnosti)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/dolozka-zlucitelnosti`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dolozkaZlucitelnosti, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DolozkaZlucitelnostiApi - functional programming interface
 * @export
 */
export const DolozkaZlucitelnostiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DolozkaZlucitelnostiApiAxiosParamCreator(configuration)
    return {
        /**
         * Create sprievodny dokument Dolozka zlucitelnosti from form data
         * @param {string} uuid Primary key of entity
         * @param {DolozkaZlucitelnosti} dolozkaZlucitelnosti 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDolozkaZlucitelnosti(uuid: string, dolozkaZlucitelnosti: DolozkaZlucitelnosti, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDolozkaZlucitelnosti(uuid, dolozkaZlucitelnosti, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DolozkaZlucitelnostiApi.createDolozkaZlucitelnosti']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit sprievodny dokument Dolozka zlucitelnosti form data
         * @param {string} uuid Primary key of entity
         * @param {DolozkaZlucitelnosti} dolozkaZlucitelnosti 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editDolozkaZlucitelnosti(uuid: string, dolozkaZlucitelnosti: DolozkaZlucitelnosti, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editDolozkaZlucitelnosti(uuid, dolozkaZlucitelnosti, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DolozkaZlucitelnostiApi.editDolozkaZlucitelnosti']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DolozkaZlucitelnostiApi - factory interface
 * @export
 */
export const DolozkaZlucitelnostiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DolozkaZlucitelnostiApiFp(configuration)
    return {
        /**
         * Create sprievodny dokument Dolozka zlucitelnosti from form data
         * @param {string} uuid Primary key of entity
         * @param {DolozkaZlucitelnosti} dolozkaZlucitelnosti 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDolozkaZlucitelnosti(uuid: string, dolozkaZlucitelnosti: DolozkaZlucitelnosti, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createDolozkaZlucitelnosti(uuid, dolozkaZlucitelnosti, stadiumUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit sprievodny dokument Dolozka zlucitelnosti form data
         * @param {string} uuid Primary key of entity
         * @param {DolozkaZlucitelnosti} dolozkaZlucitelnosti 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDolozkaZlucitelnosti(uuid: string, dolozkaZlucitelnosti: DolozkaZlucitelnosti, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.editDolozkaZlucitelnosti(uuid, dolozkaZlucitelnosti, stadiumUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DolozkaZlucitelnostiApi - object-oriented interface
 * @export
 * @class DolozkaZlucitelnostiApi
 * @extends {BaseAPI}
 */
export class DolozkaZlucitelnostiApi extends BaseAPI {
    /**
     * Create sprievodny dokument Dolozka zlucitelnosti from form data
     * @param {string} uuid Primary key of entity
     * @param {DolozkaZlucitelnosti} dolozkaZlucitelnosti 
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DolozkaZlucitelnostiApi
     */
    public createDolozkaZlucitelnosti(uuid: string, dolozkaZlucitelnosti: DolozkaZlucitelnosti, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return DolozkaZlucitelnostiApiFp(this.configuration).createDolozkaZlucitelnosti(uuid, dolozkaZlucitelnosti, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit sprievodny dokument Dolozka zlucitelnosti form data
     * @param {string} uuid Primary key of entity
     * @param {DolozkaZlucitelnosti} dolozkaZlucitelnosti 
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DolozkaZlucitelnostiApi
     */
    public editDolozkaZlucitelnosti(uuid: string, dolozkaZlucitelnosti: DolozkaZlucitelnosti, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return DolozkaZlucitelnostiApiFp(this.configuration).editDolozkaZlucitelnosti(uuid, dolozkaZlucitelnosti, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegislativnyMaterialHistoriaApi - axios parameter creator
 * @export
 */
export const LegislativnyMaterialHistoriaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Getting all history records of the legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHistoriaRecords: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getAllHistoriaRecords', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/historia`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegislativnyMaterialHistoriaApi - functional programming interface
 * @export
 */
export const LegislativnyMaterialHistoriaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegislativnyMaterialHistoriaApiAxiosParamCreator(configuration)
    return {
        /**
         * Getting all history records of the legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllHistoriaRecords(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StadiumMaterialuHistoriaList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllHistoriaRecords(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialHistoriaApi.getAllHistoriaRecords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegislativnyMaterialHistoriaApi - factory interface
 * @export
 */
export const LegislativnyMaterialHistoriaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegislativnyMaterialHistoriaApiFp(configuration)
    return {
        /**
         * Getting all history records of the legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllHistoriaRecords(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<StadiumMaterialuHistoriaList> {
            return localVarFp.getAllHistoriaRecords(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegislativnyMaterialHistoriaApi - object-oriented interface
 * @export
 * @class LegislativnyMaterialHistoriaApi
 * @extends {BaseAPI}
 */
export class LegislativnyMaterialHistoriaApi extends BaseAPI {
    /**
     * Getting all history records of the legislativny material.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialHistoriaApi
     */
    public getAllHistoriaRecords(uuid: string, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialHistoriaApiFp(this.configuration).getAllHistoriaRecords(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegislativnyMaterialSledovanieApi - axios parameter creator
 * @export
 */
export const LegislativnyMaterialSledovanieApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add authenticated user as sledovatel to legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSledovatel: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('addSledovatel', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/sledovanie`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove authenticated user as sledovatet from legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSledovatel: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteSledovatel', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/sledovanie`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegislativnyMaterialSledovanieApi - functional programming interface
 * @export
 */
export const LegislativnyMaterialSledovanieApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegislativnyMaterialSledovanieApiAxiosParamCreator(configuration)
    return {
        /**
         * Add authenticated user as sledovatel to legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSledovatel(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSledovatel(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialSledovanieApi.addSledovatel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove authenticated user as sledovatet from legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSledovatel(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSledovatel(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialSledovanieApi.deleteSledovatel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegislativnyMaterialSledovanieApi - factory interface
 * @export
 */
export const LegislativnyMaterialSledovanieApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegislativnyMaterialSledovanieApiFp(configuration)
    return {
        /**
         * Add authenticated user as sledovatel to legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSledovatel(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addSledovatel(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove authenticated user as sledovatet from legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSledovatel(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSledovatel(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegislativnyMaterialSledovanieApi - object-oriented interface
 * @export
 * @class LegislativnyMaterialSledovanieApi
 * @extends {BaseAPI}
 */
export class LegislativnyMaterialSledovanieApi extends BaseAPI {
    /**
     * Add authenticated user as sledovatel to legislativny material.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialSledovanieApi
     */
    public addSledovatel(uuid: string, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialSledovanieApiFp(this.configuration).addSledovatel(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove authenticated user as sledovatet from legislativny material.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialSledovanieApi
     */
    public deleteSledovatel(uuid: string, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialSledovanieApiFp(this.configuration).deleteSledovatel(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NavrhUzneseniaVladyApi - axios parameter creator
 * @export
 */
export const NavrhUzneseniaVladyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create sprievodny dokument Navrh uznesenia vlady/Uznesenie vlady from form data
         * @param {string} uuid Primary key of entity
         * @param {NavrhUzneseniaVlady} navrhUzneseniaVlady 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNavrhUzneseniaVlady: async (uuid: string, navrhUzneseniaVlady: NavrhUzneseniaVlady, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('createNavrhUzneseniaVlady', 'uuid', uuid)
            // verify required parameter 'navrhUzneseniaVlady' is not null or undefined
            assertParamExists('createNavrhUzneseniaVlady', 'navrhUzneseniaVlady', navrhUzneseniaVlady)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/navrh-uznesenia-vlady`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(navrhUzneseniaVlady, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update sprievodny dokument Navrh uznesenia vlady/Uznesenie vlady from form data
         * @param {string} uuid Primary key of entity
         * @param {NavrhUzneseniaVlady} navrhUzneseniaVlady 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNavrhUzneseniaVlady: async (uuid: string, navrhUzneseniaVlady: NavrhUzneseniaVlady, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('editNavrhUzneseniaVlady', 'uuid', uuid)
            // verify required parameter 'navrhUzneseniaVlady' is not null or undefined
            assertParamExists('editNavrhUzneseniaVlady', 'navrhUzneseniaVlady', navrhUzneseniaVlady)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/navrh-uznesenia-vlady`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(navrhUzneseniaVlady, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NavrhUzneseniaVladyApi - functional programming interface
 * @export
 */
export const NavrhUzneseniaVladyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NavrhUzneseniaVladyApiAxiosParamCreator(configuration)
    return {
        /**
         * Create sprievodny dokument Navrh uznesenia vlady/Uznesenie vlady from form data
         * @param {string} uuid Primary key of entity
         * @param {NavrhUzneseniaVlady} navrhUzneseniaVlady 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNavrhUzneseniaVlady(uuid: string, navrhUzneseniaVlady: NavrhUzneseniaVlady, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNavrhUzneseniaVlady(uuid, navrhUzneseniaVlady, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavrhUzneseniaVladyApi.createNavrhUzneseniaVlady']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update sprievodny dokument Navrh uznesenia vlady/Uznesenie vlady from form data
         * @param {string} uuid Primary key of entity
         * @param {NavrhUzneseniaVlady} navrhUzneseniaVlady 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editNavrhUzneseniaVlady(uuid: string, navrhUzneseniaVlady: NavrhUzneseniaVlady, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editNavrhUzneseniaVlady(uuid, navrhUzneseniaVlady, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavrhUzneseniaVladyApi.editNavrhUzneseniaVlady']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NavrhUzneseniaVladyApi - factory interface
 * @export
 */
export const NavrhUzneseniaVladyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NavrhUzneseniaVladyApiFp(configuration)
    return {
        /**
         * Create sprievodny dokument Navrh uznesenia vlady/Uznesenie vlady from form data
         * @param {string} uuid Primary key of entity
         * @param {NavrhUzneseniaVlady} navrhUzneseniaVlady 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNavrhUzneseniaVlady(uuid: string, navrhUzneseniaVlady: NavrhUzneseniaVlady, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createNavrhUzneseniaVlady(uuid, navrhUzneseniaVlady, stadiumUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Update sprievodny dokument Navrh uznesenia vlady/Uznesenie vlady from form data
         * @param {string} uuid Primary key of entity
         * @param {NavrhUzneseniaVlady} navrhUzneseniaVlady 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editNavrhUzneseniaVlady(uuid: string, navrhUzneseniaVlady: NavrhUzneseniaVlady, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.editNavrhUzneseniaVlady(uuid, navrhUzneseniaVlady, stadiumUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NavrhUzneseniaVladyApi - object-oriented interface
 * @export
 * @class NavrhUzneseniaVladyApi
 * @extends {BaseAPI}
 */
export class NavrhUzneseniaVladyApi extends BaseAPI {
    /**
     * Create sprievodny dokument Navrh uznesenia vlady/Uznesenie vlady from form data
     * @param {string} uuid Primary key of entity
     * @param {NavrhUzneseniaVlady} navrhUzneseniaVlady 
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavrhUzneseniaVladyApi
     */
    public createNavrhUzneseniaVlady(uuid: string, navrhUzneseniaVlady: NavrhUzneseniaVlady, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return NavrhUzneseniaVladyApiFp(this.configuration).createNavrhUzneseniaVlady(uuid, navrhUzneseniaVlady, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update sprievodny dokument Navrh uznesenia vlady/Uznesenie vlady from form data
     * @param {string} uuid Primary key of entity
     * @param {NavrhUzneseniaVlady} navrhUzneseniaVlady 
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavrhUzneseniaVladyApi
     */
    public editNavrhUzneseniaVlady(uuid: string, navrhUzneseniaVlady: NavrhUzneseniaVlady, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return NavrhUzneseniaVladyApiFp(this.configuration).editNavrhUzneseniaVlady(uuid, navrhUzneseniaVlady, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Getting list of sent notifications.
         * @param {string} uuid Primary key of entity
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationHistoriaList: async (uuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getNotificationHistoriaList', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/notifications`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send notification for material specified by uuid in path parameter.
         * @param {string} uuid Primary key of entity
         * @param {Notification} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotificationAsAdmin: async (uuid: string, notification: Notification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('sendNotificationAsAdmin', 'uuid', uuid)
            // verify required parameter 'notification' is not null or undefined
            assertParamExists('sendNotificationAsAdmin', 'notification', notification)
            const localVarPath = `/legislativne-materialy/{uuid}/admin-notifications`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * Getting list of sent notifications.
         * @param {string} uuid Primary key of entity
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationHistoriaList(uuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotifikaciaHistoriaPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationHistoriaList(uuid, page, size, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getNotificationHistoriaList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send notification for material specified by uuid in path parameter.
         * @param {string} uuid Primary key of entity
         * @param {Notification} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNotificationAsAdmin(uuid: string, notification: Notification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotifikaciaHistoria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNotificationAsAdmin(uuid, notification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.sendNotificationAsAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * Getting list of sent notifications.
         * @param {string} uuid Primary key of entity
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationHistoriaList(uuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<NotifikaciaHistoriaPage> {
            return localVarFp.getNotificationHistoriaList(uuid, page, size, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * Send notification for material specified by uuid in path parameter.
         * @param {string} uuid Primary key of entity
         * @param {Notification} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotificationAsAdmin(uuid: string, notification: Notification, options?: RawAxiosRequestConfig): AxiosPromise<NotifikaciaHistoria> {
            return localVarFp.sendNotificationAsAdmin(uuid, notification, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * Getting list of sent notifications.
     * @param {string} uuid Primary key of entity
     * @param {number} [page] Page number to return, indexed from one.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getNotificationHistoriaList(uuid: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getNotificationHistoriaList(uuid, page, size, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send notification for material specified by uuid in path parameter.
     * @param {string} uuid Primary key of entity
     * @param {Notification} notification 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public sendNotificationAsAdmin(uuid: string, notification: Notification, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).sendNotificationAsAdmin(uuid, notification, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ObalMaterialuFormDataApi - axios parameter creator
 * @export
 */
export const ObalMaterialuFormDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get latest created form data of sprievodny dokument obal materialu
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentUuid Primary key of sprievodny dokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestFormData: async (uuid: string, sprievodnyDokumentUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getLatestFormData', 'uuid', uuid)
            // verify required parameter 'sprievodnyDokumentUuid' is not null or undefined
            assertParamExists('getLatestFormData', 'sprievodnyDokumentUuid', sprievodnyDokumentUuid)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/{sprievodnyDokumentUuid}/obaly-materialu/detail`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"sprievodnyDokumentUuid"}}`, encodeURIComponent(String(sprievodnyDokumentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObalMaterialuFormDataApi - functional programming interface
 * @export
 */
export const ObalMaterialuFormDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObalMaterialuFormDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Get latest created form data of sprievodny dokument obal materialu
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentUuid Primary key of sprievodny dokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestFormData(uuid: string, sprievodnyDokumentUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestFormData(uuid, sprievodnyDokumentUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObalMaterialuFormDataApi.getLatestFormData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ObalMaterialuFormDataApi - factory interface
 * @export
 */
export const ObalMaterialuFormDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObalMaterialuFormDataApiFp(configuration)
    return {
        /**
         * Get latest created form data of sprievodny dokument obal materialu
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentUuid Primary key of sprievodny dokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestFormData(uuid: string, sprievodnyDokumentUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<FormData> {
            return localVarFp.getLatestFormData(uuid, sprievodnyDokumentUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObalMaterialuFormDataApi - object-oriented interface
 * @export
 * @class ObalMaterialuFormDataApi
 * @extends {BaseAPI}
 */
export class ObalMaterialuFormDataApi extends BaseAPI {
    /**
     * Get latest created form data of sprievodny dokument obal materialu
     * @param {string} uuid Primary key of entity
     * @param {string} sprievodnyDokumentUuid Primary key of sprievodny dokument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObalMaterialuFormDataApi
     */
    public getLatestFormData(uuid: string, sprievodnyDokumentUuid: string, options?: RawAxiosRequestConfig) {
        return ObalMaterialuFormDataApiFp(this.configuration).getLatestFormData(uuid, sprievodnyDokumentUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ObalMaterialuNrSrApi - axios parameter creator
 * @export
 */
export const ObalMaterialuNrSrApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create sprievodny dokument obal materialu NR SR from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuNrSr} obalMaterialuNrSr 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createObalMaterialuNrSr: async (uuid: string, obalMaterialuNrSr: ObalMaterialuNrSr, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('createObalMaterialuNrSr', 'uuid', uuid)
            // verify required parameter 'obalMaterialuNrSr' is not null or undefined
            assertParamExists('createObalMaterialuNrSr', 'obalMaterialuNrSr', obalMaterialuNrSr)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/obaly-materialu/nr-sr`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(obalMaterialuNrSr, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update sprievodny dokument obal materialu NR SR from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuNrSrUpdate} obalMaterialuNrSrUpdate 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateObalMaterialuNrSr: async (uuid: string, obalMaterialuNrSrUpdate: ObalMaterialuNrSrUpdate, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateObalMaterialuNrSr', 'uuid', uuid)
            // verify required parameter 'obalMaterialuNrSrUpdate' is not null or undefined
            assertParamExists('updateObalMaterialuNrSr', 'obalMaterialuNrSrUpdate', obalMaterialuNrSrUpdate)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/obaly-materialu/nr-sr`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(obalMaterialuNrSrUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObalMaterialuNrSrApi - functional programming interface
 * @export
 */
export const ObalMaterialuNrSrApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObalMaterialuNrSrApiAxiosParamCreator(configuration)
    return {
        /**
         * Create sprievodny dokument obal materialu NR SR from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuNrSr} obalMaterialuNrSr 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createObalMaterialuNrSr(uuid: string, obalMaterialuNrSr: ObalMaterialuNrSr, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createObalMaterialuNrSr(uuid, obalMaterialuNrSr, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObalMaterialuNrSrApi.createObalMaterialuNrSr']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update sprievodny dokument obal materialu NR SR from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuNrSrUpdate} obalMaterialuNrSrUpdate 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateObalMaterialuNrSr(uuid: string, obalMaterialuNrSrUpdate: ObalMaterialuNrSrUpdate, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateObalMaterialuNrSr(uuid, obalMaterialuNrSrUpdate, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObalMaterialuNrSrApi.updateObalMaterialuNrSr']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ObalMaterialuNrSrApi - factory interface
 * @export
 */
export const ObalMaterialuNrSrApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObalMaterialuNrSrApiFp(configuration)
    return {
        /**
         * Create sprievodny dokument obal materialu NR SR from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuNrSr} obalMaterialuNrSr 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createObalMaterialuNrSr(uuid: string, obalMaterialuNrSr: ObalMaterialuNrSr, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createObalMaterialuNrSr(uuid, obalMaterialuNrSr, stadiumUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Update sprievodny dokument obal materialu NR SR from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuNrSrUpdate} obalMaterialuNrSrUpdate 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateObalMaterialuNrSr(uuid: string, obalMaterialuNrSrUpdate: ObalMaterialuNrSrUpdate, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateObalMaterialuNrSr(uuid, obalMaterialuNrSrUpdate, stadiumUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObalMaterialuNrSrApi - object-oriented interface
 * @export
 * @class ObalMaterialuNrSrApi
 * @extends {BaseAPI}
 */
export class ObalMaterialuNrSrApi extends BaseAPI {
    /**
     * Create sprievodny dokument obal materialu NR SR from form data
     * @param {string} uuid Primary key of entity
     * @param {ObalMaterialuNrSr} obalMaterialuNrSr 
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObalMaterialuNrSrApi
     */
    public createObalMaterialuNrSr(uuid: string, obalMaterialuNrSr: ObalMaterialuNrSr, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return ObalMaterialuNrSrApiFp(this.configuration).createObalMaterialuNrSr(uuid, obalMaterialuNrSr, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update sprievodny dokument obal materialu NR SR from form data
     * @param {string} uuid Primary key of entity
     * @param {ObalMaterialuNrSrUpdate} obalMaterialuNrSrUpdate 
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObalMaterialuNrSrApi
     */
    public updateObalMaterialuNrSr(uuid: string, obalMaterialuNrSrUpdate: ObalMaterialuNrSrUpdate, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return ObalMaterialuNrSrApiFp(this.configuration).updateObalMaterialuNrSr(uuid, obalMaterialuNrSrUpdate, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ObalMaterialuNrSrBezchybnostApi - axios parameter creator
 * @export
 */
export const ObalMaterialuNrSrBezchybnostApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create obal materialu NR SR za bezchybnost from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuNrSrBezchybnost} obalMaterialuNrSrBezchybnost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createObalMaterialuNrSrBezchybnost: async (uuid: string, obalMaterialuNrSrBezchybnost: ObalMaterialuNrSrBezchybnost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('createObalMaterialuNrSrBezchybnost', 'uuid', uuid)
            // verify required parameter 'obalMaterialuNrSrBezchybnost' is not null or undefined
            assertParamExists('createObalMaterialuNrSrBezchybnost', 'obalMaterialuNrSrBezchybnost', obalMaterialuNrSrBezchybnost)
            const localVarPath = `/legislativne-materialy/{uuid}/podpis-predsedu/obal-materialu-nrsr-bezchybnost`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(obalMaterialuNrSrBezchybnost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update obal materialu NR SR za bezchybnost from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuNrSrBezchybnost} obalMaterialuNrSrBezchybnost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateObalMaterialuNrSrBezchybnost: async (uuid: string, obalMaterialuNrSrBezchybnost: ObalMaterialuNrSrBezchybnost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateObalMaterialuNrSrBezchybnost', 'uuid', uuid)
            // verify required parameter 'obalMaterialuNrSrBezchybnost' is not null or undefined
            assertParamExists('updateObalMaterialuNrSrBezchybnost', 'obalMaterialuNrSrBezchybnost', obalMaterialuNrSrBezchybnost)
            const localVarPath = `/legislativne-materialy/{uuid}/podpis-predsedu/obal-materialu-nrsr-bezchybnost`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(obalMaterialuNrSrBezchybnost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObalMaterialuNrSrBezchybnostApi - functional programming interface
 * @export
 */
export const ObalMaterialuNrSrBezchybnostApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObalMaterialuNrSrBezchybnostApiAxiosParamCreator(configuration)
    return {
        /**
         * Create obal materialu NR SR za bezchybnost from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuNrSrBezchybnost} obalMaterialuNrSrBezchybnost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createObalMaterialuNrSrBezchybnost(uuid: string, obalMaterialuNrSrBezchybnost: ObalMaterialuNrSrBezchybnost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createObalMaterialuNrSrBezchybnost(uuid, obalMaterialuNrSrBezchybnost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObalMaterialuNrSrBezchybnostApi.createObalMaterialuNrSrBezchybnost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update obal materialu NR SR za bezchybnost from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuNrSrBezchybnost} obalMaterialuNrSrBezchybnost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateObalMaterialuNrSrBezchybnost(uuid: string, obalMaterialuNrSrBezchybnost: ObalMaterialuNrSrBezchybnost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateObalMaterialuNrSrBezchybnost(uuid, obalMaterialuNrSrBezchybnost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObalMaterialuNrSrBezchybnostApi.updateObalMaterialuNrSrBezchybnost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ObalMaterialuNrSrBezchybnostApi - factory interface
 * @export
 */
export const ObalMaterialuNrSrBezchybnostApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObalMaterialuNrSrBezchybnostApiFp(configuration)
    return {
        /**
         * Create obal materialu NR SR za bezchybnost from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuNrSrBezchybnost} obalMaterialuNrSrBezchybnost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createObalMaterialuNrSrBezchybnost(uuid: string, obalMaterialuNrSrBezchybnost: ObalMaterialuNrSrBezchybnost, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createObalMaterialuNrSrBezchybnost(uuid, obalMaterialuNrSrBezchybnost, options).then((request) => request(axios, basePath));
        },
        /**
         * Update obal materialu NR SR za bezchybnost from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuNrSrBezchybnost} obalMaterialuNrSrBezchybnost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateObalMaterialuNrSrBezchybnost(uuid: string, obalMaterialuNrSrBezchybnost: ObalMaterialuNrSrBezchybnost, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.updateObalMaterialuNrSrBezchybnost(uuid, obalMaterialuNrSrBezchybnost, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObalMaterialuNrSrBezchybnostApi - object-oriented interface
 * @export
 * @class ObalMaterialuNrSrBezchybnostApi
 * @extends {BaseAPI}
 */
export class ObalMaterialuNrSrBezchybnostApi extends BaseAPI {
    /**
     * Create obal materialu NR SR za bezchybnost from form data
     * @param {string} uuid Primary key of entity
     * @param {ObalMaterialuNrSrBezchybnost} obalMaterialuNrSrBezchybnost 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObalMaterialuNrSrBezchybnostApi
     */
    public createObalMaterialuNrSrBezchybnost(uuid: string, obalMaterialuNrSrBezchybnost: ObalMaterialuNrSrBezchybnost, options?: RawAxiosRequestConfig) {
        return ObalMaterialuNrSrBezchybnostApiFp(this.configuration).createObalMaterialuNrSrBezchybnost(uuid, obalMaterialuNrSrBezchybnost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update obal materialu NR SR za bezchybnost from form data
     * @param {string} uuid Primary key of entity
     * @param {ObalMaterialuNrSrBezchybnost} obalMaterialuNrSrBezchybnost 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObalMaterialuNrSrBezchybnostApi
     */
    public updateObalMaterialuNrSrBezchybnost(uuid: string, obalMaterialuNrSrBezchybnost: ObalMaterialuNrSrBezchybnost, options?: RawAxiosRequestConfig) {
        return ObalMaterialuNrSrBezchybnostApiFp(this.configuration).updateObalMaterialuNrSrBezchybnost(uuid, obalMaterialuNrSrBezchybnost, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ObalMaterialuVseobecnyApi - axios parameter creator
 * @export
 */
export const ObalMaterialuVseobecnyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create sprievodny dokument Vseobecny obal materialu from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialu} obalMaterialu 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVseobecnyObalMaterialu: async (uuid: string, obalMaterialu: ObalMaterialu, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('createVseobecnyObalMaterialu', 'uuid', uuid)
            // verify required parameter 'obalMaterialu' is not null or undefined
            assertParamExists('createVseobecnyObalMaterialu', 'obalMaterialu', obalMaterialu)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/obaly-materialu/vseobecny`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(obalMaterialu, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update sprievodny dokument Vseobecny obal materialu from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuUpdate} obalMaterialuUpdate 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVseobecnyObalMaterialu: async (uuid: string, obalMaterialuUpdate: ObalMaterialuUpdate, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateVseobecnyObalMaterialu', 'uuid', uuid)
            // verify required parameter 'obalMaterialuUpdate' is not null or undefined
            assertParamExists('updateVseobecnyObalMaterialu', 'obalMaterialuUpdate', obalMaterialuUpdate)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/obaly-materialu/vseobecny`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(obalMaterialuUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObalMaterialuVseobecnyApi - functional programming interface
 * @export
 */
export const ObalMaterialuVseobecnyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObalMaterialuVseobecnyApiAxiosParamCreator(configuration)
    return {
        /**
         * Create sprievodny dokument Vseobecny obal materialu from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialu} obalMaterialu 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVseobecnyObalMaterialu(uuid: string, obalMaterialu: ObalMaterialu, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVseobecnyObalMaterialu(uuid, obalMaterialu, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObalMaterialuVseobecnyApi.createVseobecnyObalMaterialu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update sprievodny dokument Vseobecny obal materialu from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuUpdate} obalMaterialuUpdate 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVseobecnyObalMaterialu(uuid: string, obalMaterialuUpdate: ObalMaterialuUpdate, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVseobecnyObalMaterialu(uuid, obalMaterialuUpdate, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObalMaterialuVseobecnyApi.updateVseobecnyObalMaterialu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ObalMaterialuVseobecnyApi - factory interface
 * @export
 */
export const ObalMaterialuVseobecnyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObalMaterialuVseobecnyApiFp(configuration)
    return {
        /**
         * Create sprievodny dokument Vseobecny obal materialu from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialu} obalMaterialu 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVseobecnyObalMaterialu(uuid: string, obalMaterialu: ObalMaterialu, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createVseobecnyObalMaterialu(uuid, obalMaterialu, stadiumUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Update sprievodny dokument Vseobecny obal materialu from form data
         * @param {string} uuid Primary key of entity
         * @param {ObalMaterialuUpdate} obalMaterialuUpdate 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVseobecnyObalMaterialu(uuid: string, obalMaterialuUpdate: ObalMaterialuUpdate, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateVseobecnyObalMaterialu(uuid, obalMaterialuUpdate, stadiumUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObalMaterialuVseobecnyApi - object-oriented interface
 * @export
 * @class ObalMaterialuVseobecnyApi
 * @extends {BaseAPI}
 */
export class ObalMaterialuVseobecnyApi extends BaseAPI {
    /**
     * Create sprievodny dokument Vseobecny obal materialu from form data
     * @param {string} uuid Primary key of entity
     * @param {ObalMaterialu} obalMaterialu 
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObalMaterialuVseobecnyApi
     */
    public createVseobecnyObalMaterialu(uuid: string, obalMaterialu: ObalMaterialu, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return ObalMaterialuVseobecnyApiFp(this.configuration).createVseobecnyObalMaterialu(uuid, obalMaterialu, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update sprievodny dokument Vseobecny obal materialu from form data
     * @param {string} uuid Primary key of entity
     * @param {ObalMaterialuUpdate} obalMaterialuUpdate 
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObalMaterialuVseobecnyApi
     */
    public updateVseobecnyObalMaterialu(uuid: string, obalMaterialuUpdate: ObalMaterialuUpdate, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return ObalMaterialuVseobecnyApiFp(this.configuration).updateVseobecnyObalMaterialu(uuid, obalMaterialuUpdate, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SpravaoUcastiVerejnostiApi - axios parameter creator
 * @export
 */
export const SpravaoUcastiVerejnostiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create sprievodny dokument Sprava o ucasti verejnosti from form data
         * @param {string} uuid Primary key of entity
         * @param {SpravaOUcastiVerejnosti} spravaOUcastiVerejnosti 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpravaOUcastiVerejnosti: async (uuid: string, spravaOUcastiVerejnosti: SpravaOUcastiVerejnosti, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('createSpravaOUcastiVerejnosti', 'uuid', uuid)
            // verify required parameter 'spravaOUcastiVerejnosti' is not null or undefined
            assertParamExists('createSpravaOUcastiVerejnosti', 'spravaOUcastiVerejnosti', spravaOUcastiVerejnosti)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/sprava-o-ucasti-verejnosti`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(spravaOUcastiVerejnosti, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit sprievodny dokument Sprava o ucasti verejnosti form data
         * @param {string} uuid Primary key of entity
         * @param {SpravaOUcastiVerejnosti} spravaOUcastiVerejnosti 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSpravaoUcastiVerejnosti: async (uuid: string, spravaOUcastiVerejnosti: SpravaOUcastiVerejnosti, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('editSpravaoUcastiVerejnosti', 'uuid', uuid)
            // verify required parameter 'spravaOUcastiVerejnosti' is not null or undefined
            assertParamExists('editSpravaoUcastiVerejnosti', 'spravaOUcastiVerejnosti', spravaOUcastiVerejnosti)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/sprava-o-ucasti-verejnosti`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(spravaOUcastiVerejnosti, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SpravaoUcastiVerejnostiApi - functional programming interface
 * @export
 */
export const SpravaoUcastiVerejnostiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SpravaoUcastiVerejnostiApiAxiosParamCreator(configuration)
    return {
        /**
         * Create sprievodny dokument Sprava o ucasti verejnosti from form data
         * @param {string} uuid Primary key of entity
         * @param {SpravaOUcastiVerejnosti} spravaOUcastiVerejnosti 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSpravaOUcastiVerejnosti(uuid: string, spravaOUcastiVerejnosti: SpravaOUcastiVerejnosti, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSpravaOUcastiVerejnosti(uuid, spravaOUcastiVerejnosti, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpravaoUcastiVerejnostiApi.createSpravaOUcastiVerejnosti']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit sprievodny dokument Sprava o ucasti verejnosti form data
         * @param {string} uuid Primary key of entity
         * @param {SpravaOUcastiVerejnosti} spravaOUcastiVerejnosti 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editSpravaoUcastiVerejnosti(uuid: string, spravaOUcastiVerejnosti: SpravaOUcastiVerejnosti, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editSpravaoUcastiVerejnosti(uuid, spravaOUcastiVerejnosti, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpravaoUcastiVerejnostiApi.editSpravaoUcastiVerejnosti']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SpravaoUcastiVerejnostiApi - factory interface
 * @export
 */
export const SpravaoUcastiVerejnostiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SpravaoUcastiVerejnostiApiFp(configuration)
    return {
        /**
         * Create sprievodny dokument Sprava o ucasti verejnosti from form data
         * @param {string} uuid Primary key of entity
         * @param {SpravaOUcastiVerejnosti} spravaOUcastiVerejnosti 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpravaOUcastiVerejnosti(uuid: string, spravaOUcastiVerejnosti: SpravaOUcastiVerejnosti, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createSpravaOUcastiVerejnosti(uuid, spravaOUcastiVerejnosti, stadiumUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit sprievodny dokument Sprava o ucasti verejnosti form data
         * @param {string} uuid Primary key of entity
         * @param {SpravaOUcastiVerejnosti} spravaOUcastiVerejnosti 
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSpravaoUcastiVerejnosti(uuid: string, spravaOUcastiVerejnosti: SpravaOUcastiVerejnosti, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.editSpravaoUcastiVerejnosti(uuid, spravaOUcastiVerejnosti, stadiumUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SpravaoUcastiVerejnostiApi - object-oriented interface
 * @export
 * @class SpravaoUcastiVerejnostiApi
 * @extends {BaseAPI}
 */
export class SpravaoUcastiVerejnostiApi extends BaseAPI {
    /**
     * Create sprievodny dokument Sprava o ucasti verejnosti from form data
     * @param {string} uuid Primary key of entity
     * @param {SpravaOUcastiVerejnosti} spravaOUcastiVerejnosti 
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpravaoUcastiVerejnostiApi
     */
    public createSpravaOUcastiVerejnosti(uuid: string, spravaOUcastiVerejnosti: SpravaOUcastiVerejnosti, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return SpravaoUcastiVerejnostiApiFp(this.configuration).createSpravaOUcastiVerejnosti(uuid, spravaOUcastiVerejnosti, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit sprievodny dokument Sprava o ucasti verejnosti form data
     * @param {string} uuid Primary key of entity
     * @param {SpravaOUcastiVerejnosti} spravaOUcastiVerejnosti 
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpravaoUcastiVerejnostiApi
     */
    public editSpravaoUcastiVerejnosti(uuid: string, spravaOUcastiVerejnosti: SpravaOUcastiVerejnosti, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return SpravaoUcastiVerejnostiApiFp(this.configuration).editSpravaoUcastiVerejnosti(uuid, spravaOUcastiVerejnosti, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SprievodnyDokumentAddApi - axios parameter creator
 * @export
 */
export const SprievodnyDokumentAddApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add sprievodny dokument to legislativny material
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] 
         * @param {string} [typDokumentuUuid] 
         * @param {File} [sprievodnyDokument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSprievodnyDokument: async (uuid: string, stadiumUuid?: string, typDokumentuUuid?: string, sprievodnyDokument?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('addSprievodnyDokument', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (stadiumUuid !== undefined) { 
                localVarFormParams.append('stadiumUuid', stadiumUuid as any);
            }
    
            if (typDokumentuUuid !== undefined) { 
                localVarFormParams.append('typDokumentuUuid', typDokumentuUuid as any);
            }
    
            if (sprievodnyDokument !== undefined) { 
                localVarFormParams.append('sprievodnyDokument', sprievodnyDokument as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SprievodnyDokumentAddApi - functional programming interface
 * @export
 */
export const SprievodnyDokumentAddApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SprievodnyDokumentAddApiAxiosParamCreator(configuration)
    return {
        /**
         * Add sprievodny dokument to legislativny material
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] 
         * @param {string} [typDokumentuUuid] 
         * @param {File} [sprievodnyDokument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSprievodnyDokument(uuid: string, stadiumUuid?: string, typDokumentuUuid?: string, sprievodnyDokument?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSprievodnyDokument(uuid, stadiumUuid, typDokumentuUuid, sprievodnyDokument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentAddApi.addSprievodnyDokument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SprievodnyDokumentAddApi - factory interface
 * @export
 */
export const SprievodnyDokumentAddApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SprievodnyDokumentAddApiFp(configuration)
    return {
        /**
         * Add sprievodny dokument to legislativny material
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] 
         * @param {string} [typDokumentuUuid] 
         * @param {File} [sprievodnyDokument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSprievodnyDokument(uuid: string, stadiumUuid?: string, typDokumentuUuid?: string, sprievodnyDokument?: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addSprievodnyDokument(uuid, stadiumUuid, typDokumentuUuid, sprievodnyDokument, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SprievodnyDokumentAddApi - object-oriented interface
 * @export
 * @class SprievodnyDokumentAddApi
 * @extends {BaseAPI}
 */
export class SprievodnyDokumentAddApi extends BaseAPI {
    /**
     * Add sprievodny dokument to legislativny material
     * @param {string} uuid Primary key of entity
     * @param {string} [stadiumUuid] 
     * @param {string} [typDokumentuUuid] 
     * @param {File} [sprievodnyDokument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentAddApi
     */
    public addSprievodnyDokument(uuid: string, stadiumUuid?: string, typDokumentuUuid?: string, sprievodnyDokument?: File, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentAddApiFp(this.configuration).addSprievodnyDokument(uuid, stadiumUuid, typDokumentuUuid, sprievodnyDokument, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SprievodnyDokumentDeleteApi - axios parameter creator
 * @export
 */
export const SprievodnyDokumentDeleteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Remove sprievodny dokument.
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentUuid Primary key of sprievodny dokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSprievodnyDokument: async (uuid: string, sprievodnyDokumentUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteSprievodnyDokument', 'uuid', uuid)
            // verify required parameter 'sprievodnyDokumentUuid' is not null or undefined
            assertParamExists('deleteSprievodnyDokument', 'sprievodnyDokumentUuid', sprievodnyDokumentUuid)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/{sprievodnyDokumentUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"sprievodnyDokumentUuid"}}`, encodeURIComponent(String(sprievodnyDokumentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SprievodnyDokumentDeleteApi - functional programming interface
 * @export
 */
export const SprievodnyDokumentDeleteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SprievodnyDokumentDeleteApiAxiosParamCreator(configuration)
    return {
        /**
         * Remove sprievodny dokument.
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentUuid Primary key of sprievodny dokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSprievodnyDokument(uuid: string, sprievodnyDokumentUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSprievodnyDokument(uuid, sprievodnyDokumentUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentDeleteApi.deleteSprievodnyDokument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SprievodnyDokumentDeleteApi - factory interface
 * @export
 */
export const SprievodnyDokumentDeleteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SprievodnyDokumentDeleteApiFp(configuration)
    return {
        /**
         * Remove sprievodny dokument.
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentUuid Primary key of sprievodny dokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSprievodnyDokument(uuid: string, sprievodnyDokumentUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSprievodnyDokument(uuid, sprievodnyDokumentUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SprievodnyDokumentDeleteApi - object-oriented interface
 * @export
 * @class SprievodnyDokumentDeleteApi
 * @extends {BaseAPI}
 */
export class SprievodnyDokumentDeleteApi extends BaseAPI {
    /**
     * Remove sprievodny dokument.
     * @param {string} uuid Primary key of entity
     * @param {string} sprievodnyDokumentUuid Primary key of sprievodny dokument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentDeleteApi
     */
    public deleteSprievodnyDokument(uuid: string, sprievodnyDokumentUuid: string, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentDeleteApiFp(this.configuration).deleteSprievodnyDokument(uuid, sprievodnyDokumentUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SprievodnyDokumentDownloadApi - axios parameter creator
 * @export
 */
export const SprievodnyDokumentDownloadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSprievodnyDokument: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('downloadSprievodnyDokument', 'uuid', uuid)
            const localVarPath = `/sprievodne-dokumenty/{uuid}/download`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download sprievodny dokument by typ for concrete legislativny material
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {string} [stadiumHistoriaUuid] Stadium historia uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSprievodnyDokumentByTyp: async (uuid: string, sprievodnyDokumentKod: string, stadiumHistoriaUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('downloadSprievodnyDokumentByTyp', 'uuid', uuid)
            // verify required parameter 'sprievodnyDokumentKod' is not null or undefined
            assertParamExists('downloadSprievodnyDokumentByTyp', 'sprievodnyDokumentKod', sprievodnyDokumentKod)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/{sprievodnyDokumentKod}/download`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"sprievodnyDokumentKod"}}`, encodeURIComponent(String(sprievodnyDokumentKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumHistoriaUuid !== undefined) {
                localVarQueryParameter['stadiumHistoriaUuid'] = stadiumHistoriaUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SprievodnyDokumentDownloadApi - functional programming interface
 * @export
 */
export const SprievodnyDokumentDownloadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SprievodnyDokumentDownloadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSprievodnyDokument(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSprievodnyDokument(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentDownloadApi.downloadSprievodnyDokument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download sprievodny dokument by typ for concrete legislativny material
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {string} [stadiumHistoriaUuid] Stadium historia uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSprievodnyDokumentByTyp(uuid: string, sprievodnyDokumentKod: string, stadiumHistoriaUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSprievodnyDokumentByTyp(uuid, sprievodnyDokumentKod, stadiumHistoriaUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentDownloadApi.downloadSprievodnyDokumentByTyp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SprievodnyDokumentDownloadApi - factory interface
 * @export
 */
export const SprievodnyDokumentDownloadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SprievodnyDokumentDownloadApiFp(configuration)
    return {
        /**
         * 
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSprievodnyDokument(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSprievodnyDokument(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Download sprievodny dokument by typ for concrete legislativny material
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {string} [stadiumHistoriaUuid] Stadium historia uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSprievodnyDokumentByTyp(uuid: string, sprievodnyDokumentKod: string, stadiumHistoriaUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadSprievodnyDokumentByTyp(uuid, sprievodnyDokumentKod, stadiumHistoriaUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SprievodnyDokumentDownloadApi - object-oriented interface
 * @export
 * @class SprievodnyDokumentDownloadApi
 * @extends {BaseAPI}
 */
export class SprievodnyDokumentDownloadApi extends BaseAPI {
    /**
     * 
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentDownloadApi
     */
    public downloadSprievodnyDokument(uuid: string, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentDownloadApiFp(this.configuration).downloadSprievodnyDokument(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download sprievodny dokument by typ for concrete legislativny material
     * @param {string} uuid Primary key of entity
     * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
     * @param {string} [stadiumHistoriaUuid] Stadium historia uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentDownloadApi
     */
    public downloadSprievodnyDokumentByTyp(uuid: string, sprievodnyDokumentKod: string, stadiumHistoriaUuid?: string, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentDownloadApiFp(this.configuration).downloadSprievodnyDokumentByTyp(uuid, sprievodnyDokumentKod, stadiumHistoriaUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SprievodnyDokumentExistsApi - axios parameter creator
 * @export
 */
export const SprievodnyDokumentExistsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check if type of sprievodny dokument exists in current stadium.
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {string} [stadiumHistoriaUuid] Stadium historia uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existSprievodnyDokument: async (uuid: string, sprievodnyDokumentKod: string, stadiumHistoriaUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('existSprievodnyDokument', 'uuid', uuid)
            // verify required parameter 'sprievodnyDokumentKod' is not null or undefined
            assertParamExists('existSprievodnyDokument', 'sprievodnyDokumentKod', sprievodnyDokumentKod)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/{sprievodnyDokumentKod}/exists`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"sprievodnyDokumentKod"}}`, encodeURIComponent(String(sprievodnyDokumentKod)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumHistoriaUuid !== undefined) {
                localVarQueryParameter['stadiumHistoriaUuid'] = stadiumHistoriaUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SprievodnyDokumentExistsApi - functional programming interface
 * @export
 */
export const SprievodnyDokumentExistsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SprievodnyDokumentExistsApiAxiosParamCreator(configuration)
    return {
        /**
         * Check if type of sprievodny dokument exists in current stadium.
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {string} [stadiumHistoriaUuid] Stadium historia uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existSprievodnyDokument(uuid: string, sprievodnyDokumentKod: string, stadiumHistoriaUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SprievodnyDokumentStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existSprievodnyDokument(uuid, sprievodnyDokumentKod, stadiumHistoriaUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentExistsApi.existSprievodnyDokument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SprievodnyDokumentExistsApi - factory interface
 * @export
 */
export const SprievodnyDokumentExistsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SprievodnyDokumentExistsApiFp(configuration)
    return {
        /**
         * Check if type of sprievodny dokument exists in current stadium.
         * @param {string} uuid Primary key of entity
         * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
         * @param {string} [stadiumHistoriaUuid] Stadium historia uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existSprievodnyDokument(uuid: string, sprievodnyDokumentKod: string, stadiumHistoriaUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<SprievodnyDokumentStatus> {
            return localVarFp.existSprievodnyDokument(uuid, sprievodnyDokumentKod, stadiumHistoriaUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SprievodnyDokumentExistsApi - object-oriented interface
 * @export
 * @class SprievodnyDokumentExistsApi
 * @extends {BaseAPI}
 */
export class SprievodnyDokumentExistsApi extends BaseAPI {
    /**
     * Check if type of sprievodny dokument exists in current stadium.
     * @param {string} uuid Primary key of entity
     * @param {string} sprievodnyDokumentKod Kod of sprievodny dokument
     * @param {string} [stadiumHistoriaUuid] Stadium historia uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentExistsApi
     */
    public existSprievodnyDokument(uuid: string, sprievodnyDokumentKod: string, stadiumHistoriaUuid?: string, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentExistsApiFp(this.configuration).existSprievodnyDokument(uuid, sprievodnyDokumentKod, stadiumHistoriaUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SprievodnyDokumentListApi - axios parameter creator
 * @export
 */
export const SprievodnyDokumentListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Getting sprievodny dokument list of legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprievodnyDokumentList: async (uuid: string, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getSprievodnyDokumentList', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SprievodnyDokumentListApi - functional programming interface
 * @export
 */
export const SprievodnyDokumentListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SprievodnyDokumentListApiAxiosParamCreator(configuration)
    return {
        /**
         * Getting sprievodny dokument list of legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSprievodnyDokumentList(uuid: string, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SprievodnyDokument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSprievodnyDokumentList(uuid, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentListApi.getSprievodnyDokumentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SprievodnyDokumentListApi - factory interface
 * @export
 */
export const SprievodnyDokumentListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SprievodnyDokumentListApiFp(configuration)
    return {
        /**
         * Getting sprievodny dokument list of legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprievodnyDokumentList(uuid: string, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SprievodnyDokument>> {
            return localVarFp.getSprievodnyDokumentList(uuid, stadiumUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SprievodnyDokumentListApi - object-oriented interface
 * @export
 * @class SprievodnyDokumentListApi
 * @extends {BaseAPI}
 */
export class SprievodnyDokumentListApi extends BaseAPI {
    /**
     * Getting sprievodny dokument list of legislativny material.
     * @param {string} uuid Primary key of entity
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentListApi
     */
    public getSprievodnyDokumentList(uuid: string, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentListApiFp(this.configuration).getSprievodnyDokumentList(uuid, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SprievodnyDokumentListChangeOrderApi - axios parameter creator
 * @export
 */
export const SprievodnyDokumentListChangeOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Change order of sprievodny dokument list by admin.
         * @param {string} uuid Primary key of entity
         * @param {string} stadiumUuid 
         * @param {Array<string>} requestBody Sprievodny dokument uuid list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOrderSprievodnyDokumentList: async (uuid: string, stadiumUuid: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('changeOrderSprievodnyDokumentList', 'uuid', uuid)
            // verify required parameter 'stadiumUuid' is not null or undefined
            assertParamExists('changeOrderSprievodnyDokumentList', 'stadiumUuid', stadiumUuid)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('changeOrderSprievodnyDokumentList', 'requestBody', requestBody)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty/{stadiumUuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"stadiumUuid"}}`, encodeURIComponent(String(stadiumUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SprievodnyDokumentListChangeOrderApi - functional programming interface
 * @export
 */
export const SprievodnyDokumentListChangeOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SprievodnyDokumentListChangeOrderApiAxiosParamCreator(configuration)
    return {
        /**
         * Change order of sprievodny dokument list by admin.
         * @param {string} uuid Primary key of entity
         * @param {string} stadiumUuid 
         * @param {Array<string>} requestBody Sprievodny dokument uuid list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeOrderSprievodnyDokumentList(uuid: string, stadiumUuid: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeOrderSprievodnyDokumentList(uuid, stadiumUuid, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentListChangeOrderApi.changeOrderSprievodnyDokumentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SprievodnyDokumentListChangeOrderApi - factory interface
 * @export
 */
export const SprievodnyDokumentListChangeOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SprievodnyDokumentListChangeOrderApiFp(configuration)
    return {
        /**
         * Change order of sprievodny dokument list by admin.
         * @param {string} uuid Primary key of entity
         * @param {string} stadiumUuid 
         * @param {Array<string>} requestBody Sprievodny dokument uuid list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOrderSprievodnyDokumentList(uuid: string, stadiumUuid: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeOrderSprievodnyDokumentList(uuid, stadiumUuid, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SprievodnyDokumentListChangeOrderApi - object-oriented interface
 * @export
 * @class SprievodnyDokumentListChangeOrderApi
 * @extends {BaseAPI}
 */
export class SprievodnyDokumentListChangeOrderApi extends BaseAPI {
    /**
     * Change order of sprievodny dokument list by admin.
     * @param {string} uuid Primary key of entity
     * @param {string} stadiumUuid 
     * @param {Array<string>} requestBody Sprievodny dokument uuid list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentListChangeOrderApi
     */
    public changeOrderSprievodnyDokumentList(uuid: string, stadiumUuid: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentListChangeOrderApiFp(this.configuration).changeOrderSprievodnyDokumentList(uuid, stadiumUuid, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SprievodnyDokumentReportApi - axios parameter creator
 * @export
 */
export const SprievodnyDokumentReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create report of vznesene pripomienky v ramci MPK
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportPripomienky: async (uuid: string, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('createReportPripomienky', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/reporty/pripomienky`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create report of vyhodnotenie MPK
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportVyhodnotenieMpk: async (uuid: string, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('createReportVyhodnotenieMpk', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/reporty/vyhodnotenie-mpk`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create report of vyjadrenia k predbeznej informacii
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportVyjadrenie: async (uuid: string, stadiumUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('createReportVyjadrenie', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/reporty/vyjadrenia`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SprievodnyDokumentReportApi - functional programming interface
 * @export
 */
export const SprievodnyDokumentReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SprievodnyDokumentReportApiAxiosParamCreator(configuration)
    return {
        /**
         * Create report of vznesene pripomienky v ramci MPK
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReportPripomienky(uuid: string, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReportPripomienky(uuid, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentReportApi.createReportPripomienky']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create report of vyhodnotenie MPK
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReportVyhodnotenieMpk(uuid: string, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReportVyhodnotenieMpk(uuid, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentReportApi.createReportVyhodnotenieMpk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create report of vyjadrenia k predbeznej informacii
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReportVyjadrenie(uuid: string, stadiumUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReportVyjadrenie(uuid, stadiumUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentReportApi.createReportVyjadrenie']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SprievodnyDokumentReportApi - factory interface
 * @export
 */
export const SprievodnyDokumentReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SprievodnyDokumentReportApiFp(configuration)
    return {
        /**
         * Create report of vznesene pripomienky v ramci MPK
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportPripomienky(uuid: string, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createReportPripomienky(uuid, stadiumUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Create report of vyhodnotenie MPK
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportVyhodnotenieMpk(uuid: string, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createReportVyhodnotenieMpk(uuid, stadiumUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Create report of vyjadrenia k predbeznej informacii
         * @param {string} uuid Primary key of entity
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportVyjadrenie(uuid: string, stadiumUuid?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createReportVyjadrenie(uuid, stadiumUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SprievodnyDokumentReportApi - object-oriented interface
 * @export
 * @class SprievodnyDokumentReportApi
 * @extends {BaseAPI}
 */
export class SprievodnyDokumentReportApi extends BaseAPI {
    /**
     * Create report of vznesene pripomienky v ramci MPK
     * @param {string} uuid Primary key of entity
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentReportApi
     */
    public createReportPripomienky(uuid: string, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentReportApiFp(this.configuration).createReportPripomienky(uuid, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create report of vyhodnotenie MPK
     * @param {string} uuid Primary key of entity
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentReportApi
     */
    public createReportVyhodnotenieMpk(uuid: string, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentReportApiFp(this.configuration).createReportVyhodnotenieMpk(uuid, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create report of vyjadrenia k predbeznej informacii
     * @param {string} uuid Primary key of entity
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentReportApi
     */
    public createReportVyjadrenie(uuid: string, stadiumUuid?: string, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentReportApiFp(this.configuration).createReportVyjadrenie(uuid, stadiumUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SprievodnyDokumentZipApi - axios parameter creator
 * @export
 */
export const SprievodnyDokumentZipApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Zip of sprievodne dokumenty for current stadium.
         * @param {string} uuid Primary key of entity
         * @param {string} stadiumHistoriaUuid Stadium historia uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprievodnyDokumentZip: async (uuid: string, stadiumHistoriaUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getSprievodnyDokumentZip', 'uuid', uuid)
            // verify required parameter 'stadiumHistoriaUuid' is not null or undefined
            assertParamExists('getSprievodnyDokumentZip', 'stadiumHistoriaUuid', stadiumHistoriaUuid)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty-zip`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumHistoriaUuid !== undefined) {
                localVarQueryParameter['stadiumHistoriaUuid'] = stadiumHistoriaUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SprievodnyDokumentZipApi - functional programming interface
 * @export
 */
export const SprievodnyDokumentZipApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SprievodnyDokumentZipApiAxiosParamCreator(configuration)
    return {
        /**
         * Zip of sprievodne dokumenty for current stadium.
         * @param {string} uuid Primary key of entity
         * @param {string} stadiumHistoriaUuid Stadium historia uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSprievodnyDokumentZip(uuid: string, stadiumHistoriaUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSprievodnyDokumentZip(uuid, stadiumHistoriaUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentZipApi.getSprievodnyDokumentZip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SprievodnyDokumentZipApi - factory interface
 * @export
 */
export const SprievodnyDokumentZipApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SprievodnyDokumentZipApiFp(configuration)
    return {
        /**
         * Zip of sprievodne dokumenty for current stadium.
         * @param {string} uuid Primary key of entity
         * @param {string} stadiumHistoriaUuid Stadium historia uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprievodnyDokumentZip(uuid: string, stadiumHistoriaUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getSprievodnyDokumentZip(uuid, stadiumHistoriaUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SprievodnyDokumentZipApi - object-oriented interface
 * @export
 * @class SprievodnyDokumentZipApi
 * @extends {BaseAPI}
 */
export class SprievodnyDokumentZipApi extends BaseAPI {
    /**
     * Zip of sprievodne dokumenty for current stadium.
     * @param {string} uuid Primary key of entity
     * @param {string} stadiumHistoriaUuid Stadium historia uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentZipApi
     */
    public getSprievodnyDokumentZip(uuid: string, stadiumHistoriaUuid: string, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentZipApiFp(this.configuration).getSprievodnyDokumentZip(uuid, stadiumHistoriaUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



